import { TimePicker as AntTimePicker } from "antd";
import moment from "moment";
import React, { useMemo } from "react";
import { Controller } from "react-hook-form";
import { Label } from "reactstrap";
import MessageFormValidateV2 from "../MessageFormValidateV2";

const style = {
  height: "38px",
  borderRadius: "4px",
  borderColor: "hsl(0, 0%, 80%)",
};

const TimePicker = props => {
  const {
    mainForm,
    fieldName,
    t,
    isRequired,
    onChange,
    title,
    isLabel,
    isError,
    ...extraProps
  } = props;

  const {
    trigger,
    formState: { errors },
    control,
    setValue,
    watch,
  } = mainForm;
  const value = watch(fieldName);

  const onChangeTime = (_momentTime, _stringTime) => {
    setValue(fieldName, _stringTime);
    if (onChange !== undefined) {
      onChange(_stringTime);
    }
    trigger(fieldName);
  };

  const valueField = useMemo(() => {
    if (value && value.trim() !== "") {
      return moment(value, "HH:mm");
    }
    return undefined;
  }, [value]);

  return (
    <div className={`${isLabel ? "mb-3" : ""}`}>
      {isLabel && (
        <Label htmlFor={fieldName}>
          {title || t(`form.${fieldName}`)}{" "}
          {isRequired && <span className="text-danger">*</span>}
        </Label>
      )}

      <Controller
        control={control}
        name={fieldName}
        render={({ field }) => {
          return (
            <AntTimePicker
              style={style}
              className="text-secondary"
              size="middle"
              onChange={onChangeTime}
              value={valueField}
              {...extraProps}
            />
          );
        }}
      />
      {isError && (
        <MessageFormValidateV2 errors={errors} fieldName={fieldName} />
      )}
    </div>
  );
};

export default TimePicker;
